import React, { useState } from "react";
import { Button, Typography } from "@mui/material";

import analytics from "fond/analytics";
import { HUBSPOT_FORM_PROVIDE_FEEDBACK } from "fond/constants";
import { HubSpotModal } from "fond/hubspot/HubSpotModal";
import { useAppSelector } from "fond/utils/hooks";
import BetaChip from "fond/widgets/BetaChip";

import { Tooltip } from "./BetaNotification.styles";

interface BetaNotificationProps {
  description: string;
  feedbackFormHeader?: string;
}

const BetaNotification: React.FC<BetaNotificationProps> = ({ description, feedbackFormHeader = "Beta Feedback" }) => {
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const currentUsername = useAppSelector((state) => state.cognito.user?.username);

  const handleOnShareFeedback = () => {
    analytics.track("topbar.beta-flag.share-feedback.clicked");
    setShowFeedbackForm(true);
  };

  return (
    <>
      <Tooltip
        title={
          <>
            <Typography variant="subtitle2">Beta Program</Typography>
            {description}
            <Button fullWidth onClick={handleOnShareFeedback} sx={{ mt: 2 }} variant="contained" color="primary">
              Share Feedback
            </Button>
          </>
        }
      >
        <BetaChip label="BETA" variant="filled" size="medium" color="secondary" />
      </Tooltip>
      {showFeedbackForm && (
        <HubSpotModal
          header={feedbackFormHeader}
          formId={HUBSPOT_FORM_PROVIDE_FEEDBACK}
          initialData={{
            "0-1/email": currentUsername,
          }}
          onClose={() => setShowFeedbackForm(false)}
        />
      )}
    </>
  );
};

export default BetaNotification;
